import { render } from "./UserSettingsForm.vue?vue&type=template&id=adfd28dc&scoped=true"
import script from "./UserSettingsForm.vue?vue&type=script&lang=js"
export * from "./UserSettingsForm.vue?vue&type=script&lang=js"

import "./UserSettingsForm.vue?vue&type=style&index=0&id=adfd28dc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adfd28dc"]])

export default __exports__